require('./release/angular-recaptcha.js');
module.exports = 'vcRecaptcha';



//////////////////
// WEBPACK FOOTER
// ./~/angular-recaptcha/index.js
// module id = 139
// module chunks = 0